import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import { getLocalesForHtml } from '@src/global-locales/get-page-locales-data';
import langLocalesData from '../../langconfig.json';
import CookieSettingModal from '../cookie-setting-modal';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import { PROTOCOL } from '@src/utils/locale';
import styles from './index.less';
import CookieTipsModalStore from './store';

const lang = getLanguageByPath();

const cookieInfo = langLocalesData[lang].cookieInfo;

/**
 * CookieTipsModal
 * @param store {CookieTipsModalStore}
 * @param onClose
 * @returns {JSX.Element}
 * @constructor
 */
const CookieTipsModal = ({ store, onClose }) => {
  store.use();
  store.onClose = onClose;
  /**
   * 渲染设置cookie目的文案
   * @returns {JSX.Element}
   */
  const renderContent = () => {
    const cookieLink = PROTOCOL[lang]?.cookie;
    const description = cookieInfo?.cookie_description || '';
    const descriptionWithLink = description.replace('{link}', cookieLink);
    return (
      <div className={styles.cookieSettingDesc}>
        <span dangerouslySetInnerHTML={{ __html: descriptionWithLink }} />
      </div>
    );
  };
  const renderContainer = () => {
    if (store.showCookieSettings) {
      return <CookieSettingModal store={store.cookieSettingModalStore} onClose={store.onCookieSettingModalClose} />;
    } else {
      return (
        <div className={cx(styles.container, 'cookie-tips-modal-root')}>
          <div className={styles.closeBtn} onClick={store.onClose} />
          {renderContent()}
          <div className={styles.btnGroup}>
            <div className={cx(styles.btn)} onClick={store.onCookieSettingShowClick}>
              {cookieInfo.cookie_setting_btn}
            </div>
            <div className={cx(styles.btn)} onClick={store.rejectOptionalCookies}>
              {cookieInfo.reject_all_cookies}
            </div>
            <div className={cx(styles.btn)} onClick={store.acceptOptionalCookies}>
              {cookieInfo.allow_all_cookies}
            </div>
          </div>
        </div>
      );
    }
  };
  return (
    <ModalContainer modalState={store.isShow}>
      <div className={cx(styles.root)} ref={store.rootRef}>
        {renderContainer()}
      </div>
    </ModalContainer>
  );
};

export default wrapStore(CookieTipsModal, CookieTipsModalStore);
